import { StyleSheet } from 'aphrodite';
import { THEME } from '../../components-v2/Theme/theme';
import { backgroundAlt, brandPrimary, darkGrayFontColor, destructive, titles } from '../../styles/colors';
import { CssSelectors } from '../../styles/styles';

const { colors } = THEME;

export const styleSheet = StyleSheet.create({
	availabilityCheckButtonWrap: {
		minWidth: 120,
		flex: 1,
	},
	availabilityCheckIcon: {
		position: 'absolute',
		top: '50%',
		right: 8,
		transform: 'translateY(-50%)',
	},
	button: {
		marginTop: 16,
	},
	canspam: {
		display: 'flex',
	},
	container: {},
	domainNameActionButton: {
		transform: 'translateY(10px)',
		color: brandPrimary,
		...CssSelectors.allChildren(
			{
				display: 'block',
			},
			'span'
		),
	},
	domainNameInputWrap: {
		flex: 1,
		marginRight: 16,
	},
	domainNameInputError: {
		borderColor: destructive,
	},
	domainNameLabel: {
		display: 'inline-flex',
		position: 'relative',
		':after': {
			content: '""',
			display: 'block',
			position: 'absolute',
			left: '100%',
			top: 0,
			width: 20,
			height: 20,
			zIndex: 1,
		},
	},
	domainNameWrap: {
		display: 'flex',
		margin: '16px 0',
		alignItems: 'center',
		justifyContent: 'space-between',
	},
	domainStatusWrap: {
		display: 'flex',
		alignItems: 'center',
		marginTop: 8,
		gap: 8,
	},
	domainStatusLabel: {
		fontSize: '14px',
		color: colors.text.dark,
	},
	domainStatusMessage: {
		fontSize: '14px',
		fontWeight: 'bold',
	},
	domainStatusFailed: {
		color: colors.danger.main,
	},
	domainStatusInProgress: {
		color: colors.warning.main,
	},
	domainStatusSuccessful: {
		color: colors.success.dark,
	},
	errorRequired: {
		color: destructive,
	},
	editor: {
		height: 250,
	},
	infoPopover: {
		display: 'inline-block',
	},
	infoIcon: {
		transform: 'translate(5px, 1px)',
	},
	infoMessage: {
		fontSize: 11,
		maxWidth: 200,
		padding: '4px 8px',
		borderRadius: 4,
		backgroundColor: backgroundAlt,
		border: `1px solid ${darkGrayFontColor}`,
	},
	inputWrap: {
		position: 'relative',
	},
	input: {
		paddingRight: 23,
		maxWidth: 420,
	},
	link: {
		margin: '0 4px',
	},
	popoverWrap: {
		display: 'flex',
	},
	promptText: {
		color: titles,
		fontSize: 14,
		margin: '16px 0',
	},
	xIcon: {
		...CssSelectors.allChildren(
			{
				transform: 'translate(0px, 0px)',
			},
			'g'
		),
	},
	loaderWrap: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		minHeight: 100,
		width: '100%',
	},
	toggleWrap: {
		margin: '16px 0',
	},
	toggleText: {
		fontSize: 14,
		color: colors.text.dark,
	},
	confirmDialogContent: {
		fontSize: 14,
		lineHeight: 1.5,
		p: {
			margin: '8px 0',
		},
		ul: {
			marginLeft: 20,
			marginTop: 8,
			marginBottom: 8,
		},
		li: {
			marginBottom: 4,
		},
	},
});
